import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { sp } from 'styles/theme';
import { media } from 'styles';
import { Button, Container, TypingHero } from 'components/shared';

const HeroContainer = styled(Container)`
  position: relative;
  padding: 0 15px;
`;

const HeroButton = styled(Button)`
  margin-bottom: ${sp.max};
`;

const HeroImage = styled.div`
  display: block;
  width: 100%;
  height: auto;
  margin-bottom: -200px;

  img {
    max-width: 100%;
  }

  ${media.tablet``};
`;

const propTypes = {
  heading: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  textLines: PropTypes.arrayOf(PropTypes.string).isRequired,
  image: PropTypes.shape({
    fullSize: PropTypes.object,
    thumbnail: PropTypes.object,
  }).isRequired,
};

function Hero({ heading, buttonText, textLines, image }) {
  return (
    <HeroContainer centerText>
      <TypingHero heading={heading} lines={textLines} />

      <HeroButton blue to="/services">
        {buttonText}
      </HeroButton>

      <HeroImage>
        <img src={image.fullSize.src} alt="MarketTap" />
      </HeroImage>
    </HeroContainer>
  );
}

Hero.propTypes = propTypes;

export default Hero;



// WEBPACK FOOTER //
// ./src/components/HomePage/components/Hero/Hero.jsx